module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"work":"Работают","error":"Ошибка","inactive":"Неактивны","work:traffic-lights":"Работающих светофоров"},"en":{"work":"Work","error":"Error","inactive":"Inactive","work:traffic-lights":"Work traffic lights"}}')
  delete Component.options._Ctor
}
